/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AorvImportEintragAnmerkung
 */
export interface AorvImportEintragAnmerkung {
    /**
     * Informationstext
     * @type {string}
     * @memberof AorvImportEintragAnmerkung
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof AorvImportEintragAnmerkung
     */
    kurzText?: string;
    /**
     * 
     * @type {string}
     * @memberof AorvImportEintragAnmerkung
     */
    status?: AorvImportEintragAnmerkungStatusEnum;
}


/**
 * @export
 */
export const AorvImportEintragAnmerkungStatusEnum = {
    Ok: 'OK',
    Info: 'INFO',
    Error: 'ERROR'
} as const;
export type AorvImportEintragAnmerkungStatusEnum = typeof AorvImportEintragAnmerkungStatusEnum[keyof typeof AorvImportEintragAnmerkungStatusEnum];


/**
 * Check if a given object implements the AorvImportEintragAnmerkung interface.
 */
export function instanceOfAorvImportEintragAnmerkung(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AorvImportEintragAnmerkungFromJSON(json: any): AorvImportEintragAnmerkung {
    return AorvImportEintragAnmerkungFromJSONTyped(json, false);
}

export function AorvImportEintragAnmerkungFromJSONTyped(json: any, ignoreDiscriminator: boolean): AorvImportEintragAnmerkung {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': !exists(json, 'text') ? undefined : json['text'],
        'kurzText': !exists(json, 'kurzText') ? undefined : json['kurzText'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function AorvImportEintragAnmerkungToJSON(value?: AorvImportEintragAnmerkung | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'kurzText': value.kurzText,
        'status': value.status,
    };
}

